import { useState } from "react";

import { Button } from "./button";
import { Icon } from "./icons";
import { Textarea } from "./textarea";

// Комментарий свёрнут в «Добавить комментарий»; open — показать поле сразу (обязателен или «Другое»).
export function CommentField({
  value,
  onChange,
  open: forcedOpen,
  placeholder = "Комментарий (необязательно)",
}: {
  value: string;
  onChange: (value: string) => void;
  open?: boolean;
  placeholder?: string;
}) {
  const [open, setOpen] = useState(false);
  if (!open && !forcedOpen && !value) {
    return (
      <Button variant="ghost" size="sm" className="-ml-3 self-start" onClick={() => setOpen(true)}>
        <Icon name="plus" className="size-5" />
        Добавить комментарий
      </Button>
    );
  }
  return (
    <>
      <label htmlFor="state-comment" className="sr-only">
        Комментарий
      </label>
      <Textarea
        id="state-comment"
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </>
  );
}
